import { useState } from "react";
import {
  Box,
  Button,
  Link,
  Popover,
  Tab,
  Tabs,
  Typography
} from "@mui/material";
import QRCode from "react-qr-code";
import { useTranslation } from "react-i18next";
import { BCPAngleDown } from "../icons/bcp/BCPIcons";

const isCurrentHref = (href) => {
  return (
    href.split("?")[0].trim().toLowerCase() ===
    window.location.pathname.split("?")[0].trim().toLowerCase()
  );
};

export default function DownloadAppMenuButton(props) {
  const { title, appleLink, googleLink, href, sx } = props;
  const { t } = useTranslation("translation", {
    keyPrefix: "components.MainLayout"
  });

  const tabs = [
    appleLink && {
      key: "apple",
      label: t("appStore", { defaultValue: "Apple" }),
      link: appleLink
    },
    googleLink && {
      key: "google",
      label: t("googlePlay", { defaultValue: "Android" }),
      link: googleLink
    }
  ].filter(Boolean);

  const [anchorEl, setAnchorEl] = useState(null);
  const [activeTab, setActiveTab] = useState(tabs[0]?.key);

  if (tabs.length === 0) {
    return null;
  }

  const open = Boolean(anchorEl);
  const currentTab =
    tabs.find((tabItem) => tabItem.key === activeTab) || tabs[0];

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <Button
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="contained"
        color="banner"
        disableElevation
        onClick={handleOpen}
        endIcon={
          <BCPAngleDown style={{ "font-size": "14px", width: "14px" }} />
        }
        sx={{
          minWidth: "unset",
          ...(href && isCurrentHref(href) ? { color: "link.main" } : {}),
          ...sx
        }}
      >
        <Typography variant="h5">{title}</Typography>
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            borderRadius: 1.5,
            mt: 1,
            p: 2,
            width: 220,
            boxShadow:
              "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px"
          }
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1.5
          }}
        >
          {tabs.length > 1 && (
            <Tabs
              value={currentTab.key}
              onChange={(event, value) => setActiveTab(value)}
              variant="fullWidth"
              sx={{ minHeight: 32, width: "100%" }}
            >
              {tabs.map((tabItem) => (
                <Tab
                  key={tabItem.key}
                  value={tabItem.key}
                  label={tabItem.label}
                  sx={{ minHeight: 32, fontSize: 12 }}
                />
              ))}
            </Tabs>
          )}

          <Box
            sx={{
              p: 1,
              backgroundColor: "#fff",
              borderRadius: 1,
              display: "flex"
            }}
          >
            <QRCode value={currentTab.link} size={140} />
          </Box>

          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ textAlign: "center" }}
          >
            {t("scanToDownload", { defaultValue: "Scan to download" })}
          </Typography>
        </Box>
      </Popover>
    </>
  );
}
